<template>
    <div>
        <app-navbar/>
        <div style="margin-top: 88px;">
            <router-view :key="$route.fullPath"/>
        </div>
    </div>
</template>
<script>
import AppNavbar from '@/layout/Navbar'
export default {
  components: { AppNavbar }
}
</script>



// WEBPACK FOOTER //
// src/layout/Content.vue